module.exports = __webpack_public_path__ + "static/media/durotype-flexosoft-bold.e8586770.otf";